<template>
  <div>
    <div
      v-for="localBoundingBox in boundingBoxes"
      :key="`${localBoundingBox.top}, ${localBoundingBox.left}`"
      class="overlay"
      :style="getStyle(localBoundingBox)"
    ></div>
  </div>
</template>

<script>
import { rgbToHex } from '@/utils/color';

export default {
  props: {
    boundingBox: {
      type: Object,
      required: true,
    },
    boundingBoxes: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getStyle(localBoundingBox) {
      const isRgbColor = Array.isArray(localBoundingBox.color);
      const backgroundColor =
        (isRgbColor
          ? rgbToHex(localBoundingBox.color)
          : localBoundingBox.color) + '66';
      return {
        position: `absolute`,
        height: `${localBoundingBox.height}px`,
        width: `${localBoundingBox.width}px`,
        top: `${localBoundingBox.top - this.boundingBox.top}px`,
        left: `${localBoundingBox.left - this.boundingBox.left}px`,
        background: backgroundColor,
        borderRadius: 0,
      };
    },
  },
};
</script>
